export default "__VITE_ASSET__fUqlirfO__"